{
  "page.title":       "Tour Guide Via Baltica — Mark Jeziak, Gdańsk",
  "page.description": "Private guided tours in Gdańsk with certified local guide Mark Jeziak. English & Polish. Book your Baltic Sea city experience today.",

  "drawer.back": "Back",
  "nav.home":      "Home",
  "nav.tours":     "Tours",
  "nav.about":     "About",
  "nav.reviews":   "Reviews",
  "nav.faq":       "FAQ",
  "nav.contact":   "Contact",
  "nav.blog":      "Blog",
  "nav.cta":       "Book a Tour",

  "hero.badge":     "Private tours · Gdańsk & Pomerania",
  "hero.heading":   "Discover the soul<br>of the <em>Baltic Sea</em>",
  "hero.body":      "Private guided tours through one of Europe's most beautiful Baltic cities — where history, amber and the sea come together.",
  "hero.cta":       "Explore Tours",
  "hero.secondary": "Meet the Guide",
  "hero.stat1":     "Years guiding",
  "hero.stat2":     "Google rating",
  "hero.stat3":     "Unique routes",
  "hero.stat4":     "Languages",

  "about.badge":            "Meet your guide",
  "about.heading":          "Some cities are visited. <em>Gdańsk is understood.</em>",
  "about.p1":               "I was born in Gdańsk and I am a Gdańsk resident — immersed in the history of the most powerful port on the Baltic Sea. I have spent years learning what lies beneath the surface: the stories behind the stones, the meaning inside the monuments, the everyday soul of a city that shaped empires and changed the world. I explore the secrets of the city's side streets, Sopot's beaches and Gdynia's port. On the pillars of history, I build the contemporary story of the Tri-City. As a citizen of this place, I know its essence. As a guide, I share what that knowing has revealed.",
  "about.p2":               "I am a licensed guide and tour leader, certified by the Polish Tourist and Sightseeing Society (PTTK). I work with groups of every age and kind. Whether it is a traveller tracing the Hanseatic past, a family encountering Solidarity for the first time, or students who need history to come alive — I find the story that makes each guest stop, look up, and truly understand.",
  "about.polaroid_caption": "Mark, on the Long Embankment",
  "about.polaroid_location":"Gdańsk · Baltic Coast",
  "about.placeholder":      "Replace with a photo of Mark on location",
  "about.h1title":          "Licensed guide",
  "about.h1desc":           "Polish Tourist and Sightseeing Society (PTTK), Gdańsk. Trusted by Poland's finest tour operators.",
  "about.h2title":          "English & Polish",
  "about.h2desc":           "Native Polish, fluent English.",
  "about.h3title":          "Born in Gdańsk",
  "about.h3desc":           "Born on the Baltic coast, shaped by its history. Every nook, legend and shipyard story is part of me.",
  "about.h4title":          "{rating} on Google",
  "about.h4desc":           "{n} reviews, all five stars. Read what travellers say below.",
  "about.ctaTours":         "Browse tours →",

  "trips.badge":             "Explore Gdańsk",
  "trips.heading":           "Browse all tours",
  "trips.subheading":        "Swipe within each row to explore all tours.",
  "trips.book":              "Book this tour",
  "trips.tours":             "tours",
  "trips.from":              "from",
  "trips.from_group":        "From / group",
  "trips.prev":              "Previous",
  "trips.next":              "Next",
  "trips.drawer_label":      "Tour detail",
  "trips.drawer_close":      "Close",
  "trips.highlights":        "What we'll see",
  "trips.cancellation":      "Free cancellation up to 48h.",
  "trips.cancellation_note": "No upfront payment — confirmation by email.",

  "blog.page_title": "Blog — Via Baltica",
  "blog.badge":      "From Mark's Notebook",
  "blog.heading":    "Stories from Gdańsk",
  "blog.read_more":  "Read more →",
  "blog.back":       "← All posts",
  "blog.empty":      "No posts yet.",
  "blog.by":         "By",
  "blog.min_read":   "min read",

  "faq.eyebrow":  "Good to know",
  "faq.title":    "Common questions",
  "faq.subtitle": "A few things travellers usually ask before they book. Anything else, just write.",
  "faq.q1": "How are tours priced?",
  "faq.a1": "Tours are priced per group, not per person — so a couple pays the same as a family of five. Listed prices are starting points for groups of up to 4; larger groups and longer routes can be quoted on request. Children under 12 are free.",
  "faq.q2": "What's the cancellation policy?",
  "faq.a2": "Cancel for any reason up to 48 hours before the tour for a full refund. Weather cancellations are at my discretion and always free of charge — we can reschedule or refund.",
  "faq.q3": "Where do tours start and end?",
  "faq.a3": "Most tours start at Neptune Fountain in the Long Market, or I can meet you at your hotel anywhere in central Gdańsk, Sopot or Gdynia. Coast and day-trip tours include hotel pickup.",
  "faq.q4": "What languages do you guide in?",
  "faq.a4": "Tours are available in both Polish and English. Please let us know your preferred language when making your reservation so we can prepare your tour accordingly.",
  "faq.q5": "Are tours accessible / family-friendly?",
  "faq.a5": "Old Town tours involve cobblestones and a few stairs but are otherwise gentle and easy to pace. The family-friendly route is fully stroller-accessible. Just tell me your group's needs and we'll tailor the walk.",
  "faq.q6": "Do you offer custom routes?",
  "faq.a6": "Always. About a third of my bookings are custom — themed around food, photography, Solidarity-era history, or family roots. Tell me what you're interested in when you write.",
  "faq.q7": "Do you provide transport for day trips?",
  "faq.a7": "Yes — I own a car and use it for all private day expeditions beyond Gdańsk. A day trip by car is a great way to visit new places when time is short, and a wonderful escape from everyday life: one day, one journey, the best of Pomerania at your own pace. Hotel pickup is included in all full-day tours. Malbork, Kashubia, Toruń, the Elbląg Canal — just let me know where you'd like to go.",

  "reviews.badge":    "What travellers say",
  "reviews.heading":  "Trusted by travellers",
  "reviews.count":        "(18 reviews)",
  "reviews.count_format": "({n} reviews)",
  "reviews.cta":      "Read all reviews on Google →",
  "reviews.r1.text":  "Mark is an exceptional guide — knowledgeable, passionate, and incredibly engaging. The Via Baltica tour exceeded every expectation. Highly recommended!",
  "reviews.r1.date":  "March 2025",
  "reviews.r2.text":  "Absolutely fantastic experience in Gdańsk. Mark brings history to life in a way no textbook ever could. We'll be back for the next tour!",
  "reviews.r2.date":  "January 2025",
  "reviews.r3.text":  "One of the best guided experiences I've had in Europe. The route along Via Baltica was perfectly curated, and Mark's storytelling made every stop memorable.",
  "reviews.r3.date":  "December 2024",

  "contact.badge":       "Book your tour",
  "contact.heading":     "Book your<br>Gdańsk <em>adventure</em>",
  "contact.body":        "Not quite found what you're looking for? Tell me what you'd like to see — I will arrange it. Reach out directly and Mark will respond within 24 hours.",
  "contact.phone.label": "Phone",
  "contact.email.label": "Email",
  "contact.hours.label": "Available",
  "contact.hours.value": "Daily · 08:00 – 20:00",
  "contact.lang.label":  "Languages",
  "contact.lang.value":  "English & Polish",
  "contact.note":        "Private tours · Custom routes · Groups welcome",

  "footer.tagline":         "Eighteen years finding the streets, stories and hidden courtyards that most visitors never see.",

  "footer.col.tours":       "Tours",
  "footer.col.explore":     "Explore",
  "footer.col.reach":       "Get in touch",

  "footer.tours.all":       "Browse all tours",
  "footer.tours.gdansk":    "Walking Tours",
  "footer.tours.coast":     "Cycling Adventures",
  "footer.tours.nature":    "Day Expeditions",
  "footer.tours.book":      "Book a tour",

  "footer.explore.about":   "Meet Mark",
  "footer.explore.reviews": "Traveller reviews",
  "footer.explore.faq":     "Common questions",
  "footer.explore.blog":    "From Mark's Notebook",

  "footer.reach.address":   "Długie Ogrody 2/31",
  "footer.reach.location":  "80-765 Gdańsk, Poland",

  "footer.copyright":       "© {year} Tour Guides VIA BALTICA · Marek Jeziak. All rights reserved.",
  "footer.signature":       "Handcrafted in Gdańsk"
}